import React from "react"
import PropTypes from "prop-types"
import { get } from "../../helpers/utils"
import Typography from "../UI/Typography/Typography"
import Link from "../UI/Link/Link"
import Image from "../UI/Image/Image"
import * as styles from "./ImageLayout-tw-styles"
import { gaImageClick } from "../../constants/gtm.constants"
import useImage from "../../hooks/useImage"

const ImageLayout = props => {
  const {
    title, subtitle, heading, description, imagesCollection = {},
    image, variant, children, elementId, endNotes, onClickOnTitle } = props
  const { cardsCollection = {} } = imagesCollection
  const style = styles[variant] || styles.defaultStyle
  const images = get(cardsCollection, "items", [])
  const { altText, foregroundImg, backgroundImg } = useImage(image)

  return (
    <div id={elementId} className={style?.layoutContainer} >
      {title && <Typography content={title} className={style?.title} {...(onClickOnTitle) && {onClick:onClickOnTitle}} data-testid="ImageLayout-title" />}
      {subtitle && <Typography content={subtitle} className={style?.subtitle} data-testid="ImageLayout-subtitle" />}
      <div className={style?.textContainer}>
        {heading && <Typography content={heading} className={style?.heading} />}
        {(description || endNotes) && (
          <div className={style?.description}>
            {description &&
              <Typography
                component={React.Fragment}
                content={description}
                br_allowed={true}
                allow_br_tag={true}
              />}
            {endNotes?.content &&
              <Typography
                className={styles?.endNotes}
                content={endNotes.content}
                id={endNotes.elementId}
                allow_br_tag={true} />
            }
          </div>
        )}
        <div className={style?.imagesAndChildrenWrapper}>
          {foregroundImg &&
            <div className={style.mainImageWrapper}>
              <Image className={style?.mainImage} contentfulImage={foregroundImg} alt={altText} />
            </div>
          }
          {imagesCollection?.items?.length > 0 &&
            <div className={style?.images}>
              {imagesCollection.items.map((image, i) => (<Image key={i} className={style?.image} contentfulImage={image} />))}
            </div>
          }
          {children}
        </div>
      </div>
      {images?.length > 0 &&
        <ul className={style?.list}>{
          images.map((item, index) => {
            const { image, link, gaEventClass, title = "" } = item
            return (
              <li className={style?.listItem} key={index}>
                <Link
                  className={style?.anchor}
                  {...link}
                  gaEventClass={gaImageClick}
                  gaEventLabel={title}
                  image={image}
                  ariaLabel={title}
                >
                  <Image className={style?.imgMain} contentfulImage={image} />
                </Link>
              </li>
            )
          })}
        </ul>
      }
    </div>
  )
}

ImageLayout.propTypes = {
  title: PropTypes.string,
  onClickOnTitle: PropTypes.func,
  subtitle: PropTypes.string,
  heading: PropTypes.string,
  description: PropTypes.string,
  imagesCollection: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  image: PropTypes.object,
  variant: PropTypes.string,
  children: PropTypes.any,
  elementId: PropTypes.string,
  endNotes: PropTypes.object
}

export default ImageLayout
